import Vapi from '@borisp/vuex-rest-api'
import { getOptimisticDelete, payloadToState } from 'utils/helpers'
import { VUE_APP_BASE_API_URL }  from '../../constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    epgSources: [],
    epgSourcesMetadata: {},
    epgSource: {}
  }
})
  .get({
    action: 'getEpgSources',
    property: 'epgSources',
    queryParams: true,
    path: '/epg-sources/',
    onSuccess: payloadToState('epgSources')
  })
  .post({
    action: 'createEpgSource',
    property: 'epgSource',
    path: '/epg-sources/',
    onSuccess: payloadToState('epgSource')
  })
  .get({
    action: 'getEpgSource',
    property: 'epgSource',
    path: ({ id }) => `/epg-sources/${id}`,
    onSuccess: payloadToState('epgSource')
  })
  .put({
    action: 'updateEpgSource',
    property: 'epgSource',
    path: ({ id }) => `/epg-sources/${id}`,
    onSuccess: payloadToState('epgSource')
  })
  .delete({
    action: 'deleteEpgSource',
    property: 'epgSource',
    path: ({ id }) => `/epg-sources/${id}`,
    beforeRequest: getOptimisticDelete('epgSources'),
    onSuccess: payloadToState('epgSource')
  })
  .getStore()
